import { motion } from 'framer-motion'
import { AlertCircle, SearchX, Grid, Clock, ShoppingBag, Scan, Layout, Cpu } from 'lucide-react'
import { industryPainPoints, solutions } from '../../data'

export function HomePainPoints() {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-3xl md:text-4xl font-bold mb-4"
          >
            行业现状与解决方案
          </motion.h2>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-lg text-gray-600 max-w-2xl mx-auto"
          >
            针对当前学校食堂供应链管理的痛点，我们提供了全面的解决方案
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-semibold mb-8">行业痛点</h3>
            <div className="space-y-6">
              {industryPainPoints.map((pain, index) => (
                <motion.div
                  key={pain.id}
                  initial={{ x: -30, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm"
                >
                  <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    {pain.icon === 'alert-circle' && <AlertCircle className="w-6 h-6 text-red-500" />}
                    {pain.icon === 'search-x' && <SearchX className="w-6 h-6 text-red-500" />}
                    {pain.icon === 'scatter' && <Grid className="w-6 h-6 text-red-500" />}
                    {pain.icon === 'clock' && <Clock className="w-6 h-6 text-red-500" />}
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-2">{pain.title}</h4>
                    <p className="text-gray-600">{pain.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-8">解决方案</h3>
            <div className="space-y-6">
              {solutions.map((solution, index) => (
                <motion.div
                  key={solution.id}
                  initial={{ x: 30, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm"
                >
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    {solution.icon === 'shopping-bag' && <ShoppingBag className="w-6 h-6 text-primary-500" />}
                    {solution.icon === 'scan-line' && <Scan className="w-6 h-6 text-primary-500" />}
                    {solution.icon === 'layout-dashboard' && <Layout className="w-6 h-6 text-primary-500" />}
                    {solution.icon === 'cpu' && <Cpu className="w-6 h-6 text-primary-500" />}
                  </div>
                  <div>
                    <h4 className="text-lg font-medium mb-2">{solution.title}</h4>
                    <p className="text-gray-600">{solution.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
